var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 7.54134H8.125M6.5 5.91634V9.16634M6.53396 3.78366L6.46604 3.71569C6.27868 3.52832 6.18497 3.43464 6.07566 3.36765C5.9787 3.30825 5.87302 3.26448 5.76252 3.23794C5.63783 3.20801 5.50534 3.20801 5.24036 3.20801H3.35833C2.75161 3.20801 2.44825 3.20801 2.21651 3.32609C2.01267 3.42994 1.84694 3.59567 1.74308 3.79952C1.625 4.03125 1.625 4.33461 1.625 4.94134V9.05801C1.625 9.66473 1.625 9.96812 1.74308 10.1998C1.84694 10.4037 2.01267 10.5694 2.21651 10.6733C2.44825 10.7913 2.75161 10.7913 3.35833 10.7913H9.64167C10.2484 10.7913 10.5518 10.7913 10.7835 10.6733C10.9873 10.5694 11.1531 10.4037 11.2569 10.1998C11.375 9.96812 11.375 9.66473 11.375 9.05801V6.02467C11.375 5.41795 11.375 5.11459 11.2569 4.88285C11.1531 4.67901 10.9873 4.51328 10.7835 4.40942C10.5518 4.29134 10.2484 4.29134 9.64167 4.29134H7.75965C7.49466 4.29134 7.36217 4.29134 7.23748 4.26141C7.12698 4.23487 7.0213 4.1911 6.92434 4.1317C6.81503 4.06471 6.72133 3.97103 6.53396 3.78366Z",
    stroke: "#272D55",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionIcon);
export default __webpack_public_path__ + "static/media/SectionIcon.a62982c9e0dd6e5b44b4e01cf5038b74.svg";
export { ForwardRef as ReactComponent };